import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { Observable, Subscriber } from 'rxjs';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';

@Component({
  selector: 'app-tc-lc-mc',
  templateUrl: './tc-lc-mc.component.html',
  styleUrls: ['./tc-lc-mc.component.scss']
})
export class TCLCMCComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInput') fileInputRefs!: ElementRef[];
  @ViewChild('fileUploader') fileUploader: ElementRef;
  TcLcForm: FormGroup;
  Tclcdata = [];
  subjectList: any[] = [];
  filteredSubjectList: any[] = [];
  dialogRef: MatDialogRef<any>;
  TCList: any;
  filterTCList: any;
  facultyList: any;
  filteredFacultyList: any;
  filteredCollegeList: any;
  CollegeList: any;
  examList: any;
  filteredExamList: any;
  courseStreamList: any;
  filteredStreamList: any;
  courseList: any;
  filteredCourseList: any;
  DestcollegeList: any;
  filteredDestCollegeList: any;
  StuId: any;
  TclcData: any = [];
  Table = false;
  Approved = false;
  InstId: any;
  RptCode: number;
  College = true;
  University = false;
  PayFee = false
  CgCode: any;
  filteredDestUniList: any;
  DestUniList: any;
  Status: string;
  SaveDisabled = false;
  CertStatus: any;
  Other = false;
  SaveBtn = false;
  UpdateBtn = false;
  PayDisabled = false;
  PayRecpt = false;
  AnserSheet = false;
  DocTable = false;
  DocView = false;
  fileName: string;
  errormessage: string;
  uploadDoc: any;
  fileUploads: any;
  SavedDocument: any;
  abc: any;
  xyz: any;
  DocErr: any;
  valuesArray: any;
  ducumentList: any;
  errMsg: any;
  selectedCert: any;
  TclcDocData: any;
  UpdateDisabled: boolean;
  ShowExam: boolean = true;
  ShowCollege: boolean = true;
  Subjects: any[] = [];
  SubjectName: any[] = [];
  AllSub: any[] = [];
  selectedCheckboxes: any[] = [];
  selectedOptions: any[] = [];
  GroupData: any[] = [];
  SubjectData: any[] = [];
  newSelectedValues: any[] = [];
  selectedSubject: number = 0;
  AllSubjectData: any = []
  Subject: boolean = false;
  Subs: boolean = false;
  OptSub: boolean = false;
  BranchId = 0;
  PaymentResponseId = null;
  subjectHeadList: any[] = [];
  filteredSubjectHeadList: any[] = [];
  allSubjectHeadsWithParent: any[] = []; // holds all heads with owning subject id
  allSubjectHeadsSelected = false;
  allSubjectsSelected = false;
  private subjectChangeSub: any;

  // Per-head ASC state tracking (Save / Pay / Receipt)
  pendingHeads: any[] = [];    // selected heads with NO DB record -> Save
  payableHeads: any[] = [];    // selected heads with DB record but FeeStatus != 'Y' -> Pay
  receiptHeads: any[] = [];    // selected heads with DB record and FeeStatus == 'Y' -> Receipt

  // Per-row (per Subject Head) Answer Sheet Copy state — one entry per head id
  answerSheetAvailableMap: { [headId: number]: boolean } = {};
  answerSheetDownloadDisabledMap: { [headId: number]: boolean } = {};
  answerSheetDataMap: { [headId: number]: any } = {};
  waitingForAdminUploadMap: { [headId: number]: boolean } = {};
  lastCheckedTimeMap: { [headId: number]: Date } = {};
  retryCountMap: { [headId: number]: number } = {};
  maxRetries: number = 3;

  languageCertAvailable: boolean = false;
  languageDownloadDisabled: boolean = true;
  languageCertData: any = null;
  showLanguageButton: boolean = false;
  waitingForAdminUploadLang: boolean = false;
  lastCheckedTimeLang: Date = null;
  retryCountLang: number = 0;
  maxRetriesLang: number = 3;
  vodAvailable: boolean = false;
  vodDownloadDisabled: boolean = true;
  vodData: any = null;
  showVodButton: boolean = false;
  waitingForAdminUploadVod: boolean = false;
  lastCheckedTimeVod: Date = null;
  retryCountVod: number = 0;
  maxRetriesVod: number = 3;

  //  Guard flags to prevent infinite API loops for LANG
  private langAvailabilityChecked = false;
  private langFeeValidated = false;

  ascCutoffRecords: any[] = [];
  ascCutoffValid: boolean = false;
  ascCutoffMessage: string = '';
  ascCutoffChecked: boolean = false;

  deliveryList = [
    { value: 'option1', dropdownValue: 'Soft', Value: 'Soft Copy' },
    { value: 'option1', dropdownValue: 'Hard', Value: 'Hard Copy' },
    { value: 'option1', dropdownValue: 'Both', Value: 'Both' }
  ];
  deliveryOptionList = [
    { value: 'option1', deliveryOptionValue: 'IN', Value: 'Within India Delivery' },
    { value: 'option1', deliveryOptionValue: 'OFI', Value: 'Out Of India Delivery' },
  ];
  isReadonly = false;

  constructor(public umsService: UmsService, private fb: FormBuilder, public dialog: MatDialog,
    private modalPopupService: ModalpopService, private spinner: NgxSpinnerService, public router: Router,
  ) { }

  ngOnInit(): void {
    this.UpdateBtn = false;
    this.DocTable = false;
    this.DocView = false;
    this.SaveBtn = false;
    this.SaveDisabled = true;
    this.Other = false;
    this.College = true;
    this.University = false;
    this.PayFee = false;
    this.Table = false;
    this.PayDisabled = false
    this.UpdateDisabled = false;

    // Initialize per-row Answer Sheet Copy state maps
    this.answerSheetAvailableMap = {};
    this.answerSheetDownloadDisabledMap = {};
    this.answerSheetDataMap = {};
    this.waitingForAdminUploadMap = {};
    this.lastCheckedTimeMap = {};
    this.retryCountMap = {};

    this.languageCertAvailable = false;
    this.languageDownloadDisabled = true;
    this.languageCertData = null;
    this.showLanguageButton = false;
    this.waitingForAdminUploadLang = false;
    this.lastCheckedTimeLang = null;
    this.retryCountLang = 0;

    this.vodAvailable = false;
    this.vodDownloadDisabled = true;
    this.vodData = null;
    this.showVodButton = false;
    this.waitingForAdminUploadVod = false;
    this.lastCheckedTimeVod = null;
    this.retryCountVod = 0;

    // Reset subject head properties
    this.subjectHeadList = [];
    this.filteredSubjectHeadList = [];
    this.allSubjectHeadsSelected = false;
    this.allSubjectsSelected = false;

    // Reset per-head ASC state
    this.pendingHeads = [];
    this.payableHeads = [];
    this.receiptHeads = [];

    //  Reset LANG guard flags
    this.langAvailabilityChecked = false;
    this.langFeeValidated = false;

    // ========== NEW: Reset ASC Cutoff properties ==========
    this.ascCutoffRecords = [];
    this.ascCutoffValid = false;
    this.ascCutoffMessage = '';
    this.ascCutoffChecked = false;
    // ======================================================

    this.TcLcForm = this.fb.group({
      SelectedSubject: new FormControl(''),
      SelectedSubjectHead: new FormControl(''),
      StuFaculty: new FormControl(''),
      StuExam: new FormControl(''),
      StuCourse: new FormControl(''),
      StuBranch: new FormControl(0),
      StuCollege: new FormControl(''),
      DestCollege: new FormControl(''),
      reason: new FormControl(''),
      Other: new FormControl(''),
      StuCertificate: new FormControl(''),
      // LANG fields
      mobileNo: new FormControl('', [Validators.pattern('^[0-9]{10}$')]),
      email: new FormControl('', [Validators.email]),
      address: new FormControl(''),
      // Delivery fields for LANG
      DeliveryOpt: new FormControl(''),
      emailId: new FormControl(''),
      postalAdd: new FormControl(''),
      deliverAt: new FormControl(''),
      isSameAddr: new FormControl(false),
      arrData: this.fb.array([]),
    })
    this.getStuId()
    this.fetchTcLcMc();
    this.getSecretData();
    this.TcLcForm.get('isSameAddr')?.valueChanges.subscribe(checked => {
      if (checked) {
        const addr = this.TcLcForm.get('address')?.value;
        if (addr) {
          this.TcLcForm.get('postalAdd')?.setValue(addr);
          this.isReadonly = true;
        }
      } else {
        this.TcLcForm.get('postalAdd')?.setValue('');
        this.isReadonly = false;
      }
    });
  }

  getStuId() {
    this.spinner.show()
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.StuId = res.data[0].StuId
        this.RgId(res.data[0].StuId)
        this.SubjectSelectionData(res.data[0].StuId)
      }
      else {
        this.spinner.hide()
        this.SaveDisabled = true;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisabled = true;
    })
  }

  SubjectSelectionData(StuId) {
    const payload = {};
    payload['StuId'] = StuId
    this.umsService.StudentSubjectSelectionById(payload).subscribe(res => {
      if (res.status) {
        const latestObject = res.data[res.data.length - 1];
        this.getCourseData(latestObject['SubCoId']);
        this.getCollege(latestObject['SubCgId']);
        this.getFacultyData(latestObject['SubFacId']);
        this.getExam(latestObject['SubCoId'], latestObject['SubEmId']);
        this.getExamStreamData(latestObject['SubCoId'], latestObject['SubBrId']);
      }
      else {
      }
    })
  }

  getCourseData(CoCode) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.fetchCourseType(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
        this.TcLcForm.controls['StuCourse'].setValue(res.data[0]['CoCode'])
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getCollege(CgCode) {
    this.spinner.show()
    const payload3 = {};
    this.umsService.getCollege(payload3).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.CollegeList = res.data.filter(record => record.CgCode === CgCode);
        this.filteredCollegeList = this.CollegeList.slice();
        this.TcLcForm.controls['StuCollege'].setValue(this.CollegeList[0]['CgCode'])
        this.CgCode = CgCode
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  DestCollege() {
    this.spinner.show()
    const payload3 = {};
    this.umsService.getCollege(payload3).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.DestcollegeList = res.data.filter(record => record.CgCode != this.CgCode)
        this.filteredDestCollegeList = this.DestcollegeList.slice();
        this.ShowGrid()
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  GetUniversity() {
    this.spinner.show()
    const payload3 = {};
    payload3['UniCode'] = ''
    this.umsService.GetUniversity(payload3).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.DestUniList = res.data
        this.filteredDestUniList = this.DestUniList.slice();
        this.ShowGrid()
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  getFacultyData(id) {
    this.spinner.show()
    const payload = {};
    payload['FcCode'] = id;
    this.umsService.fetchFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.facultyList = res.data;
        this.filteredFacultyList = this.facultyList.slice();
        this.TcLcForm.controls['StuFaculty'].setValue(res.data[0]['FcCode'])
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  getExam(CoCode, id) {
    this.spinner.show()
    const payload2 = {};
    payload2['EmCoCode'] = CoCode;
    payload2['EmId'] = id;
    this.umsService.fetchExam(payload2).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
        this.TcLcForm.controls['StuExam'].setValue(res.data[0]['EmId'])
        this.getSubjectsForCourse();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  getExamStreamData(id, BrId) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = id;
    this.umsService.fetchCourseBranch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseStreamList = res.data.filter(data => data.StrId == parseInt(BrId));
        this.filteredStreamList = this.courseStreamList.slice();
        this.TcLcForm.controls['StuBranch'].setValue(res.data[0]['StrId'])
      }
      else {
        this.spinner.hide()
        this.BranchId = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }


  fetchTcLcMc() {
    //this.spinner.show()
    const payload = {};
    payload['CdType'] = 'RF';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.TCList = res.data;
        this.filterTCList = this.TCList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  enablePayAfterSaveASC() {
    if (this.TcLcForm?.value?.StuCertificate === 'ASC' || this.TcLcForm?.value?.StuCertificate === 'RET') {
      this.PayFee = true;
      this.PayDisabled = false;
    }
  }

  getCertLabel(): string {
    return this.TcLcForm?.value?.StuCertificate === 'RET' ? 'Retotaling of marks' : 'Photocopy of answerbook';
  }

  getCertDefaultFileName(): string {
    return this.TcLcForm?.value?.StuCertificate === 'RET' ? 'Retotaling of marks.pdf' : 'Photocopy of answerbook.pdf';
  }

  onSelectAllSubjectHeadsChange() {
    this.allSubjectHeadsSelected = !this.allSubjectHeadsSelected;

    if (this.allSubjectHeadsSelected) {
      const allHeadIds = this.subjectHeadList.map(h => h.EsId);
      this.TcLcForm.controls['SelectedSubjectHead'].setValue(allHeadIds);
    } else {
      this.TcLcForm.controls['SelectedSubjectHead'].setValue([]);
    }

    // Refresh table + buttons because programmatic setValue doesn't fire selectionChange
    if (this.TcLcForm.value['StuCertificate'] === 'ASC' || this.TcLcForm.value['StuCertificate'] === 'RET') {
      this.onSubjectHeadChange({ value: this.TcLcForm.value.SelectedSubjectHead });
    }
  }
    onSelectAllChange() {
    this.allSubjectsSelected = !this.allSubjectsSelected;

    if (this.allSubjectsSelected) {
      const allSubjectIds = this.subjectList.map(s => s.EsId);
      this.TcLcForm.controls['SelectedSubject'].setValue(allSubjectIds);
    } else {
      this.TcLcForm.controls['SelectedSubject'].setValue([]);
    }
  }

   // When Subject Head selection changes, evaluate per-head state (Save / Pay / Receipt)
  onSubjectHeadChange(event: any) {
    // Only run for ASC / RET
    if (this.TcLcForm.value['StuCertificate'] !== 'ASC' && this.TcLcForm.value['StuCertificate'] !== 'RET') {
      return;
    }

    // Normalize the selected heads into an array of valid numeric ids
    const raw = event?.value ?? this.TcLcForm.value.SelectedSubjectHead ?? [];
    const selectedHeads: number[] = Array.isArray(raw)
      ? raw
          .map((v: any) => Number(v))
          .filter((v: number) => !!v && !isNaN(v) && v > 0)
      : [];

    this.evaluateASCHeadState(selectedHeads);
  }

checkASCCutoffValidation(): Promise<boolean> {
  return new Promise((resolve) => {
    // ASC and RET share the same session cutoff — no new cutoff needed for RET
    if (this.TcLcForm.value['StuCertificate'] !== 'ASC' && this.TcLcForm.value['StuCertificate'] !== 'RET') {
      this.ascCutoffValid = true;
      this.ascCutoffChecked = true;
      resolve(true);
      return;
    }

    // Dynamic label for the current certificate type
    const certLabel = this.getCertLabel();

    this.spinner.show();
    const payload = {};
    payload['SnNo']    = parseInt(sessionStorage.getItem('session'));     
    // Always query with 'ASC' so RET reuses the ASC cutoff dates
    payload['InCode']  = 'ASC';
    payload['CgCode']  = this.TcLcForm.value['StuCollege'] || this.CgCode;  
    payload['CoCode']  = this.TcLcForm.value['StuCourse'];               
    payload['EmId']    = String(this.TcLcForm.value['StuExam'] || '');     

    console.log('ASC Cutoff payload:', payload);   

    this.umsService.CheckValidDate(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.ascCutoffChecked = true;
        console.log('ASC Cutoff response:', res);  

        if (res.status && res.data && res.data.length > 0) {
          this.ascCutoffRecords = res.data;
          const todayDate = new Date();
          todayDate.setHours(0, 0, 0, 0);

          let listCanOpen = false;
          let message = '';

          const ascRecords = res.data.filter(record => 
            record.InCode === 'ASC' &&
            record.CoCgCoCode == this.TcLcForm.value['StuCourse'] &&
            record.CoCgCgCode == (this.TcLcForm.value['StuCollege'] || this.CgCode)
          );

          console.log('Filtered ASC records:', ascRecords);  

          if (ascRecords.length === 0) {
            if (res.data.length === 0) {
              this.ascCutoffValid = false;
              this.ascCutoffMessage = `${certLabel} application for this session has not opened yet. Please check back later or wait for the official university schedule announcement`;
              resolve(false);
              return;
            }
          }

          for (const item of ascRecords) {
            const fromDate = new Date(item.FromDate);
            const toDate = new Date(item.ToDate);
            fromDate.setHours(0, 0, 0, 0);
            toDate.setHours(0, 0, 0, 0);

            if (todayDate >= fromDate && todayDate <= toDate) {
              listCanOpen = true;
              break;
            } else if (todayDate < fromDate) {
              message = `${certLabel} Dates Are Still Not Open`;
            } else if (todayDate > toDate) {
              message = `${certLabel} Dates Are Closed`;
            }
          }

          if (listCanOpen) {
            this.ascCutoffValid = true;
            this.ascCutoffMessage = '';
            resolve(true);
          } else {
            this.ascCutoffValid = false;
            this.ascCutoffMessage = message || `${certLabel} Is Not Available At This Time`;
            resolve(false);
          }
        } else {
          this.ascCutoffValid = false;
          this.ascCutoffMessage = `${certLabel} application for this session has not opened yet. Please check back later or wait for the official university schedule announcement`;
          resolve(false);
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.ascCutoffChecked = true;
        this.ascCutoffValid = false;
        this.ascCutoffMessage = 'Error checking cutoff dates. Please try again.';
        console.error('Error checking ASC cutoff:', err);
        resolve(false);
      }
    });
  });
}
  showCutoffAlert(message: string): void {
    let data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  }
  evaluateASCHeadState(selectedHeads: number[]) {
    // Reset state
    this.pendingHeads = [];
    this.payableHeads = [];
    this.receiptHeads = [];

    // Reset button flags for ASC / RET
    this.SaveBtn = false;
    this.PayFee = false;
    this.PayDisabled = false;
    this.PayRecpt = false;
    this.Table = false;
    this.TclcData = [];

    // Reset per-row Answer Sheet maps for the new evaluation
    this.answerSheetAvailableMap = {};
    this.answerSheetDownloadDisabledMap = {};
    this.answerSheetDataMap = {};
    this.waitingForAdminUploadMap = {};
    this.lastCheckedTimeMap = {};
    this.retryCountMap = {};

    // Sanitize: keep only valid numeric ids (drop 0, NaN, null, '')
    const validHeads: number[] = Array.isArray(selectedHeads)
      ? selectedHeads
          .map((v: any) => Number(v))
          .filter((v: number) => !!v && !isNaN(v) && v > 0)
      : [];
    selectedHeads = validHeads;

    if (!Array.isArray(selectedHeads) || selectedHeads.length === 0) {
      // No valid heads selected -> nothing to do
      return;
    }

    // Determine the current certificate type (ASC or RET) so we filter DB rows correctly
    const currentCert: string = this.TcLcForm.value['StuCertificate'] === 'RET' ? 'RET' : 'ASC';

    this.spinner.show();
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = currentCert;

    this.umsService.GetTclcData(payload).subscribe((res) => {
      this.spinner.hide();

      const allRows: any[] = (res?.status && Array.isArray(res.data))
        ? res.data.filter((d: any) => d.StuId == this.StuId && d.CertType == currentCert)
        : [];

      const rowByHead = new Map<number, any>();
      allRows.forEach(r => {
        const id = Number(r.StuSubId);
        if (!!id && !isNaN(id) && id > 0) {
          rowByHead.set(id, r);
        }
      });

      // Classify each selected head (skip invalid ids)
      selectedHeads.forEach(headId => {
        const numericId = Number(headId);

        // Skip empty / null / NaN / 0 ids
        if (!numericId || isNaN(numericId) || numericId <= 0) {
          return;
        }

        const row = rowByHead.get(numericId);
        if (!row) {
          // No record in DB yet -> needs Save
          const headInfo = this.subjectHeadList.find(h => h.EsId === numericId);
          this.pendingHeads.push(headInfo || { EsId: numericId, EsName: String(numericId) });
        } else if (row.FeeStatus !== 'Y') {
          // Record exists but unpaid -> needs Pay
          this.payableHeads.push(row);
        } else {
          // Record exists and paid -> Receipt
          this.receiptHeads.push(row);
        }
      });

      // Set the visible rows for the ASC / RET table (only existing rows)
      this.TclcData = [...this.payableHeads, ...this.receiptHeads];

      const hasPending = this.pendingHeads.length > 0;
      const hasPayable = this.payableHeads.length > 0;
      const hasReceipt = this.receiptHeads.length > 0;

      if (hasPending) {
        this.SaveBtn = true;
        this.SaveDisabled = false;
        this.PayFee = false;
        this.PayDisabled = false;
        this.PayRecpt = false;
      } else if (hasPayable) {
        this.SaveBtn = false;
        this.SaveDisabled = false;
        this.PayFee = true;
        this.PayDisabled = false;
        this.PayRecpt = false;
      } else if (hasReceipt) {
        this.SaveBtn = false;
        this.SaveDisabled = false;
        this.PayFee = false;
        this.PayDisabled = false;
        this.PayRecpt = true;
      } else {
        this.SaveBtn = false;
        this.SaveDisabled = false;
        this.PayFee = false;
        this.PayDisabled = false;
        this.PayRecpt = false;
      }

      this.AllSubjectData = allRows;

      if (this.receiptHeads.length > 0) {
        this.PaymentResponseId = this.receiptHeads[0].PaymentResponseID;
        this.checkAnswerSheetAvailabilityForAllRows();
      }
      if (this.pendingHeads.length > 0) {
        const creds = this.TcLcForm.get('arrData') as FormArray;
        if (!creds || creds.length === 0) {
          this.GetTcLcDocs();
        }
        this.DocTable = true;
        this.DocView = false;
      } else {
        this.DocTable = false;
        this.DocView = false;
      }
    });
  }

  shouldShowAnswerSheetButtonForRow(row: any): boolean {
    const cert = this.TcLcForm.value['StuCertificate'];
    if (cert !== 'ASC' && cert !== 'RET') return false;
    if (!row || row.FeeStatus !== 'Y') return false;

    const headId = Number(row.StuSubId);
    return !!this.answerSheetAvailableMap[headId];
  }
  isDownloadDisabledForRow(row: any): boolean {
    if (!row) return true;
    const headId = Number(row.StuSubId);
    return this.answerSheetDownloadDisabledMap[headId] === true;
  }

  checkAnswerSheetAvailabilityForAllRows(): void {
    const cert = this.TcLcForm.value['StuCertificate'];
    if (cert !== 'ASC' && cert !== 'RET') return;
    if (!Array.isArray(this.TclcData) || this.TclcData.length === 0) return;

    const paidRows = this.TclcData.filter((r: any) => r.FeeStatus === 'Y');

    paidRows.forEach(row => {
      const headId = Number(row.StuSubId);
      if (!headId || isNaN(headId) || headId <= 0) return;
      this.checkAnswerSheetAvailabilityForHead(headId);
    });
  }
  checkAnswerSheetAvailabilityForHead(headId: number): void {
    const session = JSON.parse(sessionStorage.getItem('session') || '{}');
    // Use the current form cert type so RET checks RET documents and ASC checks ASC documents
    const certType: string = this.TcLcForm.value['StuCertificate'] === 'RET' ? 'RET' : 'ASC';

    const payload = {
      SessionId: session.SessionId || session.SnNo || 0,
      StuId: Number(sessionStorage.getItem('StudentPersonalId')) || 0,
      Emid: Number(sessionStorage.getItem('StuEmId')) || 0,
      StuSubId: headId,
    };

    this.umsService.GetTcLcDocUploadDetails(payload).subscribe({
      next: (res: any) => {
        const ascDocs = (res?.status && Array.isArray(res.data))
          ? res.data.filter((doc: any) => doc.CertType === certType)
          : [];

        const matchedDoc = ascDocs.find(
          (doc: any) => doc.FileUpload && doc.FileUpload.trim() !== ''
        );

        if (matchedDoc) {
          this.answerSheetAvailableMap[headId] = true;
          this.answerSheetDataMap[headId] = matchedDoc;
          this.answerSheetDownloadDisabledMap[headId] = false;
          this.waitingForAdminUploadMap[headId] = false;
        } else {
          this.answerSheetAvailableMap[headId] = false;
          this.answerSheetDataMap[headId] = null;
          this.answerSheetDownloadDisabledMap[headId] = true;
          this.waitingForAdminUploadMap[headId] = true;
          this.lastCheckedTimeMap[headId] = new Date();
        }
      },
      error: (err) => {
        console.error('Error checking answer sheet for head', headId, err);
        this.answerSheetAvailableMap[headId] = false;
        this.answerSheetDownloadDisabledMap[headId] = true;
      }
    });
  }

  downloadAnswerSheetCopyForRow(row: any): void {
    if (!row) return;
    const headId = Number(row.StuSubId);
    // Use the current form cert type so RET downloads RET documents and ASC downloads ASC documents
    const certType: string = this.TcLcForm.value['StuCertificate'] === 'RET' ? 'RET' : 'ASC';
    // Dynamic label for messages and file name
    const certLabel = this.getCertLabel();

    if (!this.answerSheetAvailableMap[headId]) {
      this.showPopup(`${certLabel} is not available for download.`, 'Information');
      return;
    }
    if (this.answerSheetDownloadDisabledMap[headId]) {
      this.showPopup(`Cannot download ${certLabel}. Please ensure all conditions are met.`, 'Information');
      return;
    }

    const session = JSON.parse(sessionStorage.getItem('session') || '{}');
    const payload = {
      SessionId: session.SessionId || session.SnNo || 0,
      StuId: Number(sessionStorage.getItem('StudentPersonalId')) || 0,
      Emid: Number(sessionStorage.getItem('StuEmId')) || 0,
      StuSubId: headId,
    };

    this.spinner.show();

    this.umsService.GetTcLcDocUploadDetails(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        const doc = (res?.status && Array.isArray(res.data))
          ? res.data.find(
              (d: any) => d.CertType === certType && d.FileUpload && d.FileUpload.trim() !== ''
            )
          : null;

        if (!doc || !doc.FileUpload) {
          this.showPopup(`${certLabel} has not been uploaded by admin yet. Please try again in a few days.`, 'Information');
          this.waitingForAdminUploadMap[headId] = true;
          this.lastCheckedTimeMap[headId] = new Date();
          return;
        }

        this.downloadPDFFile(doc);
        this.waitingForAdminUploadMap[headId] = false;
        this.retryCountMap[headId] = 0;
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Download failed', err);
        this.showPopup('Download failed. Please try again.', 'Error');

        this.retryCountMap[headId] = (this.retryCountMap[headId] || 0) + 1;
        if (this.retryCountMap[headId] >= this.maxRetries) {
          this.showPopup('Maximum retry attempts reached. Please contact administrator.', 'Error');
          this.answerSheetDownloadDisabledMap[headId] = true;
        }
      }
    });
  }

  // Helper method to get selected subject head names for display
  getSelectedSubjectHeadNames(): string {
    const selectedHeads = this.TcLcForm.value.SelectedSubjectHead;
    if (!selectedHeads || !Array.isArray(selectedHeads) || selectedHeads.length === 0) {
      return '';
    }
    const names = this.subjectHeadList
      .filter(h => selectedHeads.includes(h.EsId))
      .map(h => h.EsName);
    return names.join(', ');
  }

  // Helper method to get selected subject names for display
  getSelectedSubjectNames(): string {
    const selectedSubjects = this.TcLcForm.value.SelectedSubject;
    if (!selectedSubjects || !Array.isArray(selectedSubjects) || selectedSubjects.length === 0) {
      return '';
    }
    const names = this.subjectList
      .filter(s => selectedSubjects.includes(s.EsId))
      .map(s => s.SubName);
    return names.join(', ');
  }

  // Method to check if a subject head is selected
  isSubjectHeadSelected(esId: number): boolean {
    const selected = this.TcLcForm.value.SelectedSubjectHead;
    return Array.isArray(selected) && selected.includes(esId);
  }

  // Method to check if a subject is selected
  isSubjectSelected(esId: number): boolean {
    const selected = this.TcLcForm.value.SelectedSubject;
    return Array.isArray(selected) && selected.includes(esId);
  }

  // Toggle individual subject head selection
  toggleSubjectHead(esId: number) {
    let selected = this.TcLcForm.value.SelectedSubjectHead || [];
    if (!Array.isArray(selected)) {
      selected = [];
    }
    if (selected.includes(esId)) {
      selected = selected.filter(id => id !== esId);
    } else {
      selected.push(esId);
    }
    this.TcLcForm.controls['SelectedSubjectHead'].setValue(selected);
    this.allSubjectHeadsSelected = selected.length === this.subjectHeadList.length;
  }

  // Toggle individual subject selection
  toggleSubject(esId: number) {
    let selected = this.TcLcForm.value.SelectedSubject || [];
    if (!Array.isArray(selected)) {
      selected = [];
    }
    if (selected.includes(esId)) {
      selected = selected.filter(id => id !== esId);
    } else {
      selected.push(esId);
    }
    this.TcLcForm.controls['SelectedSubject'].setValue(selected);
    this.allSubjectsSelected = selected.length === this.subjectList.length;
  }

  // ========== MODIFIED: Save() method with ASC/RET cutoff validation ==========
  Save() {
    const cert = this.TcLcForm.value['StuCertificate'];

    if (cert === 'TS' || cert === 'ATTFE' || cert === 'VOD') {
      return;
    }

    // ========== NEW: For ASC and RET, validate cutoff dates before proceeding ==========
    if (cert === 'ASC' || cert === 'RET') {
      this.checkASCCutoffValidation().then((isValid) => {
        if (!isValid) {
          this.showCutoffAlert(this.ascCutoffMessage || `${this.getCertLabel()} Is Not Available At This Time`);
          return;
        }
        // Cutoff is valid, proceed with normal save flow
        this.proceedWithSave(cert);
      });
      return;
    }

    this.proceedWithSave(cert);
  }
  private proceedWithSave(cert: string) {
    // this.spinner.show();
    this.Table = cert !== 'ASC' && cert !== 'RET' && cert !== 'LANG';
    if ((cert === 'TC' || cert === 'MC' || cert === 'ASC' || cert === 'RET') && this.TcLcForm.value['DestCollege'] == "") {
      const creds = this.TcLcForm.get('arrData') as FormArray;
      let hasEmptyFile = false;

      creds.controls.forEach(element => {
        if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').updateValueAndValidity();
          element.get('DocumentFile').markAsTouched();
          hasEmptyFile = true;
        } else {
          element.get('DocumentFile').clearValidators();
          element.get('DocumentFile').updateValueAndValidity();
        }
      });

      this.TcLcForm.get('DestCollege').setValidators([Validators.required]);
      this.TcLcForm.get('DestCollege').updateValueAndValidity();
      this.TcLcForm.get('DestCollege').markAsTouched();

      if (!hasEmptyFile) {
        this.Submit();  
      } else {
        this.spinner.hide();  
      }
    }
    else if ((cert === 'TC' || cert === 'MC' || cert === 'ASC' || cert === 'RET') && this.TcLcForm.value['DestCollege'] != "") {
      const creds = this.TcLcForm.get('arrData') as FormArray;
      let hasEmptyFile = false;

      creds.controls.forEach(element => {
        if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').updateValueAndValidity();
          element.get('DocumentFile').markAsTouched();
          hasEmptyFile = true;
        } else {
          element.get('DocumentFile').clearValidators();
          element.get('DocumentFile').updateValueAndValidity();
        }
      });

      if (!hasEmptyFile) {
        this.Submit();
      } else {
        this.spinner.hide();
      }
    }
    else if (cert === 'LANG') {
      const mobileControl = this.TcLcForm.get('mobileNo');
      const emailControl = this.TcLcForm.get('email');
      const addressControl = this.TcLcForm.get('address');
      if (mobileControl?.invalid || emailControl?.invalid || addressControl?.invalid) {
        mobileControl?.markAsTouched();
        emailControl?.markAsTouched();
        addressControl?.markAsTouched();
        let data = { message: 'Please fill all mandatory fields (Mobile, Email, Address) correctly', title: 'Validation Error', icon: 'fas fa-close' };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.spinner.hide();
        return;
      }
      const creds = this.TcLcForm.get('arrData') as FormArray;
      let hasEmptyFile = false;
      creds.controls.forEach(element => {
        if (!element.value.DocumentFile || element.value.DocumentFile === '') {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').updateValueAndValidity();
          element.get('DocumentFile').markAsTouched();
          hasEmptyFile = true;
        } else {
          element.get('DocumentFile').clearValidators();
          element.get('DocumentFile').updateValueAndValidity();
        }
      });

      if (hasEmptyFile) {
        let data = { message: 'Please upload all required documents', title: 'Validation Error', icon: 'fas fa-close' };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.spinner.hide();
        return;
      }
      this.Submit();
    }
    else {
      this.TcLcForm.get('DestCollege').clearValidators();
      this.TcLcForm.get('DestCollege').updateValueAndValidity();
      const creds = this.TcLcForm.get('arrData') as FormArray;
      creds.controls.forEach(element => {
        element.get('DocumentFile').clearValidators();
        element.get('DocumentFile').updateValueAndValidity();
      });
      this.Submit();
    }
  }


 Submit() {
    this.TcLcForm.controls.arrData.value
    const submitpayload = this.TcLcForm.value
    const certType = submitpayload.StuCertificate;

    let payload = {}
    payload['StuFaculty'] = submitpayload.StuFaculty,
      payload['StuCourse'] = submitpayload.StuCourse,
      payload['StuCollege'] = submitpayload.StuCollege,
      payload['StuExam'] = submitpayload.StuExam,
      payload['StuBranch'] = submitpayload.StuBranch,
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = certType,
      payload['DestClg'] = submitpayload.DestCollege,
      payload['Reason'] = submitpayload.reason,
      payload['Other'] = submitpayload.Other,
      payload['FeeStatus'] = '';
    payload['CertStatus'] = 'Submitted';
    payload['StuId'] = this.StuId;
    payload['Comment'] = '';
    payload['CertScr'] = '';
    payload['StatusBy'] = sessionStorage.getItem('loginId');
    payload['DocStatus'] = 'Y';

    if (certType !== 'ASC' && certType !== 'RET') {
      delete payload['StuSubId'];
    }
    if (certType === 'LANG') {
      payload['MobileNo'] = submitpayload.mobileNo;
      payload['Email'] = submitpayload.email;
      payload['Address'] = submitpayload.address;
      // Delivery fields for LANG
      payload['DeliveryOpt'] = submitpayload.DeliveryOpt;
      payload['EmailId'] = submitpayload.emailId;
      payload['PostalAdd'] = submitpayload.postalAdd;
      payload['DeliverAt'] = submitpayload.deliverAt;
      payload['IsSameAddr'] = submitpayload.isSameAddr ? 'Y' : 'N';
    }

    // For ASC / RET with multiple subject heads, we need to loop
    if (certType === 'ASC' || certType === 'RET') {
      this.submitASCWithMultipleHeads(payload);
      return;
    }

    this.umsService.AddTclc(payload).subscribe((res) => {
      if (res.status) {
        this.enablePayAfterSaveASC();
        if (certType === 'ASC' || certType === 'RET') {
          this.Table = false;
          this.PayFee = true;
          this.PayDisabled = false;
          this.SaveBtn = false;
        } else if (certType === 'LANG') {
          this.Table = false;
          this.PayFee = true;
          this.PayDisabled = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
        }

        if (this.TcLcForm.controls.arrData.value.length == 0) {
          this.spinner.hide()
          this.saveApplicationDetails();
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            if (certType === 'ASC' || certType === 'RET' || certType === 'LANG') {
              this.PayFee = true;
              this.PayDisabled = false;
              this.Table = false;
              this.SaveBtn = false;
              this.UpdateBtn = false;
            } else {
              this.ShowGrid()
            }
          });
        }
        else {
          this.AddTclcDoc()
        }
      }
      else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    })
  }

   // New method to submit ASC / RET with multiple subject heads - calls API in loop.
  // Only pending heads (those with no DB record yet) are submitted.
  async submitASCWithMultipleHeads(basePayload: any) {
    const pendingHeads = this.pendingHeads;

    if (!Array.isArray(pendingHeads) || pendingHeads.length === 0) {
      this.spinner.hide();
      let data = { message: 'All selected Subject Heads are already submitted.', title: 'Information', icon: 'fas fa-info-circle' };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      return;
    }

    this.spinner.show();
    let successCount = 0;
    let errorMessages: string[] = [];
    const totalCalls = pendingHeads.length;

    // Process each pending head sequentially — one API call per head
    for (let i = 0; i < pendingHeads.length; i++) {
      const headItem = pendingHeads[i];
      const headId = Number(headItem?.EsId);

      // Skip invalid head ids so we never post StuSubId = 0
      if (!headId || isNaN(headId) || headId <= 0) {
        errorMessages.push(`Skipped invalid Subject Head id for ${headItem?.EsName || 'unknown'}`);
        continue;
      }

      const callPayload = { ...basePayload };

      // StuSubId = the selected Subject Head's EsId (head id)
      callPayload['StuSubId'] = headId;

      try {
        const res: any = await this.addTclcPromise(callPayload);
        if (res && res.status) {
          successCount++;
        } else {
          errorMessages.push(res?.message || `Failed for ${headItem.EsName || headItem.EsId}`);
        }
      } catch (err) {
        errorMessages.push((err as any)?.error?.message || `Error for ${headItem.EsName || headItem.EsId}`);
      }
    }

    this.spinner.hide();

    if (successCount > 0) {
      // Save was successful → refresh head state so Pay buttons appear
      this.saveApplicationDetails();

      if (this.TcLcForm.controls.arrData.value.length > 0) {
        this.AddTclcDoc();
      }

      let data = {
        message: `Submitted Successfully (${successCount} of ${totalCalls} requests)`,
        title: 'Information',
        icon: 'fas fa-check'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        // Re-evaluate so Pay / Receipt buttons show for the newly saved heads
        const raw = this.TcLcForm.value.SelectedSubjectHead || [];
        const selectedHeads: number[] = Array.isArray(raw)
          ? raw.map((v: any) => Number(v)).filter((v: number) => !!v && !isNaN(v) && v > 0)
          : [];
        this.evaluateASCHeadState(selectedHeads);
      });
    } else {
      let data = {
        message: errorMessages.length > 0 ? errorMessages.join('; ') : 'Submission failed.',
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    }
  }

  // Helper promise wrapper for AddTclc
  addTclcPromise(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.umsService.AddTclc(payload).subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  UpdateTclcDoc() {
    const submitpayload = this.TcLcForm.value
    const certType = submitpayload.StuCertificate;

    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.TcLcForm.controls.arrData.value.forEach((element, index, array) => {
        let payload = {};
        payload['StuId'] = this.StuId,
          payload['CertType'] = submitpayload.StuCertificate,
          payload['DocName'] = element.DocumentName,
          payload['FileUpload'] = this.fileUploads[index];
        payload['TclcDocId'] = element.TclcDocId
        setTimeout(() => {
          this.umsService.UpdateTclcDoc(payload).subscribe(res => {
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            } else {
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            this.fileUploader.nativeElement.value = null;
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          if (certType === 'ASC' || certType === 'RET') {
            this.Table = false;
            this.PayFee = true;
            this.PayDisabled = false;
            this.SaveBtn = false;
            this.UpdateBtn = false;
          } else {
            this.ShowGrid()
          }
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          if (certType === 'ASC' || certType === 'RET') {
            this.Table = false;
          } else {
            this.ShowGrid()
          }
        });
      }
    });
  }

  AddTclcDoc() {
    const submitpayload = this.TcLcForm.value
    const certType = submitpayload.StuCertificate;

    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.TcLcForm.controls.arrData.value.forEach((element, index, array) => {
        let payload = {};
        payload['StuId'] = this.StuId,
          payload['CertType'] = submitpayload.StuCertificate,
          payload['DocName'] = element.DocumentName,
          payload['FileUpload'] = this.fileUploads[index];
        setTimeout(() => {
          this.umsService.AddTclcDoc(payload).subscribe(res => {
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            } else {
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            this.fileUploader.nativeElement.value = null;
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.spinner.hide();
        this.saveApplicationDetails();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          if (certType === 'ASC' || certType === 'RET') {
            this.Table = false;
            this.PayFee = true;
            this.PayDisabled = false;
            this.SaveBtn = false;
            this.UpdateBtn = false;
            this.DocTable = false;
            this.DocView = false;
          } else {
            this.ShowGrid()
          }
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          if (certType === 'ASC' || certType === 'RET') {
            this.Table = false;
            this.PayFee = false;
            this.SaveBtn = true;
          } else {
            this.ShowGrid()
          }
        });
      }
    });
  }

  Update() {
    const submitpayload = this.TcLcForm.value
    const certType = this.TclcData[0]?.CertType;

    if (certType === 'LANG') {
      const mobileControl = this.TcLcForm.get('mobileNo');
      const emailControl = this.TcLcForm.get('email');
      const addressControl = this.TcLcForm.get('address');
      if (mobileControl?.invalid || emailControl?.invalid || addressControl?.invalid) {
        mobileControl?.markAsTouched();
        emailControl?.markAsTouched();
        addressControl?.markAsTouched();
        let data = { message: 'Please fill all mandatory fields (Mobile, Email, Address) correctly', title: 'Validation Error', icon: 'fas fa-close' };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        return;
      }

      const creds = this.TcLcForm.get('arrData') as FormArray;
      let hasEmptyFile = false;
      creds.controls.forEach(element => {
        if (!element.value.DocumentFile || element.value.DocumentFile === '') {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').updateValueAndValidity();
          element.get('DocumentFile').markAsTouched();
          hasEmptyFile = true;
        } else {
          element.get('DocumentFile').clearValidators();
          element.get('DocumentFile').updateValueAndValidity();
        }
      });

      if (hasEmptyFile) {
        let data = { message: 'Please upload all required documents', title: 'Validation Error', icon: 'fas fa-close' };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        return;
      }
    }

    let payload = {}
    payload['StuFaculty'] = this.TclcData[0]['StuFaculty'],
      payload['StuCourse'] = this.TclcData[0]['StuCourse'],
      payload['StuCollege'] = this.TclcData[0]['StuCollege'],
      payload['StuExam'] = this.TclcData[0]['StuExam'],
      payload['StuBranch'] = this.TclcData[0]['StuBranch'],
      payload['SnNo'] = this.TclcData[0]['SnNo'],
      payload['CertType'] = this.TclcData[0]['CertType'],
      payload['DestClg'] = submitpayload.DestCollege,
      payload['Reason'] = submitpayload.reason,
      payload['Other'] = submitpayload.Other,
      payload['FeeStatus'] = this.TclcData[0]['FeeStatus'],
      payload['CertStatus'] = 'ReSubmitted';
    payload['StuId'] = this.TclcData[0]['StuId'],
      payload['TclcId'] = this.TclcData[0]['TclcId'],
      payload['StatusBy'] = sessionStorage.getItem('loginId'),
      payload['Comment'] = '',
      payload['CertScr'] = '';
    if (this.TclcData[0]['CertType'] === 'LANG') {
      payload['MobileNo'] = submitpayload.mobileNo;
      payload['Email'] = submitpayload.email;
      payload['Address'] = submitpayload.address;
      payload['DeliveryOpt'] = submitpayload.DeliveryOpt;
      payload['EmailId'] = submitpayload.emailId;
      payload['PostalAdd'] = submitpayload.postalAdd;
      payload['DeliverAt'] = submitpayload.deliverAt;
      payload['IsSameAddr'] = submitpayload.isSameAddr ? 'Y' : 'N';
    }

    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.UpdateTclcDoc()
      }
      else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    })
  }


  redirectTo(to, data): void {
    this.router.navigate([to, data]);
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  ShowTable(data) {
    this.TcLcForm.get('StuCertificate')?.setValue(data);
    this.TcLcForm.get('DestCollege')?.clearValidators();
    this.TcLcForm.get('DestCollege')?.updateValueAndValidity();
    this.TcLcForm.get('DestCollege')?.markAsUntouched();
    this.TcLcForm.controls['DestCollege'].setValue('');
    this.TcLcForm.controls['reason'].setValue('');
    this.Other = false;
    this.Table = false;

    // Reset per-row Answer Sheet Copy state
    this.answerSheetAvailableMap = {};
    this.answerSheetDownloadDisabledMap = {};
    this.answerSheetDataMap = {};
    this.waitingForAdminUploadMap = {};
    this.lastCheckedTimeMap = {};
    this.retryCountMap = {};

    this.languageCertAvailable = false;
    this.languageDownloadDisabled = true;
    this.languageCertData = null;
    this.showLanguageButton = false;
    this.vodAvailable = false;
    this.vodDownloadDisabled = true;
    this.vodData = null;
    this.showVodButton = false;
    this.waitingForAdminUploadVod = false;

    // Reset LANG guard flags whenever certificate type changes
    this.langAvailabilityChecked = false;
    this.langFeeValidated = false;

    // Reset subject head selections
    this.TcLcForm.controls['SelectedSubjectHead'].setValue([]);
    this.TcLcForm.controls['SelectedSubject'].setValue([]);
    this.allSubjectHeadsSelected = false;
    this.allSubjectsSelected = false;

    // Reset per-head ASC / RET state
    this.pendingHeads = [];
    this.payableHeads = [];
    this.receiptHeads = [];
    this.ascCutoffRecords = [];
    this.ascCutoffValid = false;
    this.ascCutoffMessage = '';
    this.ascCutoffChecked = false;

    if (data == 'TC' || data == 'LC') {
      this.College = true;
      this.University = false;
      this.DestCollege();
    }
    if (data == 'ASC' || data == 'RET') {
      this.College = false;
      this.ShowExam = false;
      this.ShowCollege = false;
      this.Subject = true;
      this.Table = false;
      this.DocTable = false;
      this.PayFee = false;
      this.PayDisabled = false;
      this.SaveBtn = true;
      this.SaveDisabled = false;
      if (this.StuId && this.TcLcForm.value.StuCourse && this.TcLcForm.value.StuExam) {
        this.getSubjectsForCourse();
      }
    }
    else if (data == 'LANG') {
      this.College = true;
      this.University = false;
      this.ShowExam = false;
      this.ShowCollege = true;
      this.Subject = false;
      this.Table = false;
      this.DocTable = true;
      this.PayFee = false;
      this.PayDisabled = false;
      this.SaveBtn = true;
      this.SaveDisabled = false;
      this.TcLcForm.patchValue({ mobileNo: '', email: '', address: '' });
      this.TcLcForm.patchValue({ DeliveryOpt: '', emailId: '', postalAdd: '', deliverAt: '', isSameAddr: false });
      this.GetTcLcDocs();
      this.ShowGrid();
    }
    else if (data == 'MC') {
      this.College = false;
      this.University = true;
      this.GetUniversity();
    }
    else if (data == 'ADMC') {
      this.College = false;
      this.University = false;
      this.ShowGrid();
    }
    else if (data == 'TS') {
      this.selectedCert = data;
      if (this.StuId != null || this.StuId != undefined) {
        this.redirect('Transcript');
      } else if (this.StuId === undefined) {
        this.redirect('old-transcript');
      }
    }
    else if (data == 'ATTFE') {
      this.selectedCert = data;
      if (this.StuId != null || this.StuId != undefined) {
        this.redirect('attestation');
      } 
    }
    else if (data == 'VOD') {
      this.selectedCert = data;
      if (this.StuId != null || this.StuId != undefined) {
        this.redirect('Verification_DOC');
      }
    }
  }

  // VOD specific methods (similar to Answer Sheet and Language Certificate)
  shouldShowVodDownloadButton(): boolean {
    return this.TcLcForm.value['StuCertificate'] === 'VOD' &&
      this.showVodButton &&
      this.TclcData &&
      this.TclcData.length > 0;
  }

  isVodDownloadDisabled(): boolean {
    return this.vodDownloadDisabled || !this.vodAvailable;
  }

  checkVodAvailability(): void {
    if (this.TcLcForm.value['StuCertificate'] !== 'VOD') {
      this.showVodButton = false;
      return;
    }
    
    if (this.TclcData && this.TclcData.length > 0) {
      const vodRecord = this.TclcData.find((t: any) => t.CertType === 'VOD');
      if (!vodRecord || vodRecord.FeeStatus !== 'Y') {
        this.vodAvailable = false;
        this.vodDownloadDisabled = true;
        this.showVodButton = false;
        return;
      }
    } else {
      this.showVodButton = false;
      return;
    }

    const session = JSON.parse(sessionStorage.getItem('session') || '{}');
    const payload = {
      SessionId: session.SessionId || session.SnNo || 0,
      StuId: Number(sessionStorage.getItem('StudentPersonalId')) || 0,
      CertType: 'VOD'
    };

    this.umsService.GetTcLcDocUploadDetails(payload).subscribe({
      next: (res: any) => {
        if (!res?.status || !res?.data?.length) {
          this.vodAvailable = false;
          this.vodDownloadDisabled = true;
          this.vodData = null;
          this.showPopup('No VOD document data found. Please contact administrator.', 'Information');
          return;
        }

        const vodDocs = res.data.filter((doc: any) => doc.CertType === 'VOD');

        if (vodDocs.length === 0) {
          this.vodAvailable = false;
          this.vodDownloadDisabled = true;
          this.vodData = null;
          this.waitingForAdminUploadVod = true;
          this.showPopup('VOD document has not been uploaded by admin yet. Please try again in a few days.', 'Information');
          return;
        }

        let matchedDoc = vodDocs.find((doc: any) => doc.FileUpload && doc.FileUpload.trim() !== '');
        
        if (matchedDoc) {
          this.vodAvailable = true;
          this.vodData = matchedDoc;
          this.waitingForAdminUploadVod = false;

          const conditionsMatch = this.checkDownloadConditionsVod(matchedDoc);
          this.vodDownloadDisabled = !conditionsMatch;

          if (!conditionsMatch) {
            this.showPopup('VOD document is available but does not match required criteria. Please contact administrator.', 'Information');
          } else {
            this.showVodButton = true;
          }
        } else {
          this.vodAvailable = false;
          this.vodDownloadDisabled = true;
          this.vodData = null;
          this.waitingForAdminUploadVod = true;
          this.showPopup('VOD document has not been uploaded by admin yet. Please try again in a few days.', 'Information');
        }
      },
      error: (err) => {
        console.error('Error checking VOD availability:', err);
        this.vodAvailable = false;
        this.vodDownloadDisabled = true;
        this.showPopup('Unable to check VOD availability. Please try again later.', 'Error');
      }
    });
  }

  checkDownloadConditionsVod(docData: any): boolean {
    try {
      if (this.TcLcForm.value['StuCertificate'] !== 'VOD') return false;

      if (this.TclcData && this.TclcData.length > 0) {
        const vodRecord = this.TclcData[0];
        if (!vodRecord || vodRecord.FeeStatus !== 'Y') return false;
      }

      if (!docData || !docData.FileUpload || docData.FileUpload.trim() === '') return false;

      if (this.waitingForAdminUploadVod && this.lastCheckedTimeVod) {
        const now = new Date();
        const diffInHours = (now.getTime() - this.lastCheckedTimeVod.getTime()) / (1000 * 60 * 60);
        if (diffInHours < 24) return false;
      }

      return true;
    } catch (error) {
      console.error('Error checking VOD download conditions:', error);
      return false;
    }
  }

  downloadVodDocument(): void {
    if (!this.vodAvailable) {
      this.showPopup('VOD document is not available for download.', 'Information');
      return;
    }
    
    if (this.vodDownloadDisabled) {
      this.showPopup('Cannot download VOD document. Please ensure all conditions are met.', 'Information');
      return;
    }

    if (!this.checkDownloadConditionsVod(this.vodData)) {
      this.showPopup('VOD document does not match required criteria. Please contact administrator.', 'Information');
      return;
    }

    const session = JSON.parse(sessionStorage.getItem('session') || '{}');
    const payload = {
      SessionId: session.SessionId || session.SnNo || 0,
      StuId: Number(sessionStorage.getItem('StudentPersonalId')) || 0,
      CertType: 'VOD'
    };

    this.spinner.show();

    this.umsService.GetTcLcDocUploadDetails(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        
        if (!res?.status || !res?.data?.length) {
          this.showPopup('No document data found.', 'Error');
          return;
        }

        const doc = res.data.find((d: any) => 
          d.CertType === 'VOD' && 
          d.FileUpload && 
          d.FileUpload.trim() !== ''
        );
        
        if (!doc || !doc.FileUpload) {
          this.showPopup('VOD document has not been uploaded by admin yet. Please try again in a few days.', 'Information');
          this.waitingForAdminUploadVod = true;
          this.lastCheckedTimeVod = new Date();
          return;
        }

        this.downloadPDFFile(doc);
        this.waitingForAdminUploadVod = false;
        this.retryCountVod = 0;
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Download failed', err);
        this.showPopup('Download failed. Please try again.', 'Error');
        this.retryCountVod++;
        if (this.retryCountVod >= this.maxRetriesVod) {
          this.showPopup('Maximum retry attempts reached. Please contact administrator.', 'Error');
          this.vodDownloadDisabled = true;
        }
      }
    });
  }

 ShowGrid() {
  this.spinner.show()
  const Data = this.TcLcForm.value
  const submitpayload = this.TcLcForm.value

  if (Data.StuCertificate === 'ASC' || Data.StuCertificate === 'RET') {
    this.selectedSubject = submitpayload.SelectedSubject
    // Normalize selected heads and delegate to per-head evaluation
    const raw = submitpayload.SelectedSubjectHead || [];
    const selectedHeads: number[] = Array.isArray(raw)
      ? raw.map((v: any) => Number(v)).filter((v: number) => !!v && !isNaN(v) && v > 0)
      : [];
    this.evaluateASCHeadState(selectedHeads);
    this.spinner.hide();
    return;
  }
  else if (Data.StuCertificate === 'LANG') {
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = 'LANG'

    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status && res.data.length > 0) {
        this.TclcData = res.data.filter(data => data.StuId == this.StuId && data.CertType == 'LANG')
        if (this.TclcData.length > 0) {
          this.Table = false;
          this.PayFee = true;
          this.PayDisabled = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          this.DocTable = true;
          this.DocView = true;
          this.PayRecpt = false;
          if (this.TclcData[0]['MobileNo']) this.TcLcForm.patchValue({ mobileNo: this.TclcData[0]['MobileNo'] });
          if (this.TclcData[0]['Email']) this.TcLcForm.patchValue({ email: this.TclcData[0]['Email'] });
          if (this.TclcData[0]['Address']) this.TcLcForm.patchValue({ address: this.TclcData[0]['Address'] });
          if (this.TclcData[0]['DeliveryOpt']) this.TcLcForm.patchValue({ DeliveryOpt: this.TclcData[0]['DeliveryOpt'] });
          if (this.TclcData[0]['EmailId']) this.TcLcForm.patchValue({ emailId: this.TclcData[0]['EmailId'] });
          if (this.TclcData[0]['PostalAdd']) this.TcLcForm.patchValue({ postalAdd: this.TclcData[0]['PostalAdd'] });
          if (this.TclcData[0]['DeliverAt']) this.TcLcForm.patchValue({ deliverAt: this.TclcData[0]['DeliverAt'] });
          if (this.TclcData[0]['IsSameAddr'] === 'Y') this.TcLcForm.patchValue({ isSameAddr: true });

          this.getDocDetails();

          // ===== Status handling for LANG (mirrors TS behaviour) =====
          switch (this.TclcData[0]['CertStatus']) {
            case "APR":
              this.Status = 'Approved';
              this.Approved = true;
              this.UpdateDisabled = true;
              break;
            case "APPAP":
              this.Status = 'Application Approved';
              this.Approved = true;
              this.UpdateDisabled = true;
              break;
            case "REJ":
              this.Status = 'Rejected';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = true;          // ← show Update for student to re-upload
              this.SaveBtn = false;
              break;
            case "REC":
              this.Status = 'Rectify';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = true;
              this.SaveBtn = false;
              break;
            case "ReSubmitted":
              this.Status = 'Re-Submitted';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = false;
              break;
            default:
              this.Status = this.TclcData[0]['CertStatus'];
              this.Approved = false;
              this.UpdateDisabled = false;
              break;
          }

          if (this.TclcData[0]['FeeStatus'] == 'Y') {
            this.PayDisabled = true;
            this.PayRecpt = true;
            this.PayFee = false;
            this.showLanguageButton = true;
            this.checkLanguageCertificateAvailability();
            this.PaymentResponseId = this.TclcData[0].PaymentResponseID
            this.Table = true;
          }
          else if (this.TclcData[0]['FeeStatus'] != 'Y') {
            this.PayRecpt = false;
            this.PayFee = true;
            this.SaveBtn = false;
            this.SaveDisabled = false;
            this.showLanguageButton = false;
            // ✅ Guard: only call ValidateFee once per data load to prevent infinite loop
            if (!this.langFeeValidated) {
              this.langFeeValidated = true;
              this.ValidateFee(this.TclcData[0]['StuId'], this.TclcData[0]['CertType'], this.TclcData[0])
            }
            this.Table = true;
          }
          else {
            this.PayRecpt = false;
            this.PayFee = false;
            this.SaveBtn = true;
            this.SaveDisabled = false;
            this.showLanguageButton = false;
          }
          // ===== END status handling =====
        } else {
          this.Table = false;
          this.PayFee = false;
          this.SaveBtn = true;
          this.SaveDisabled = false;
          this.UpdateBtn = false;
          this.showLanguageButton = false;
          this.DocTable = true;
          this.DocView = false;
          this.GetTcLcDocs();
        }
      } else {
        this.Table = false;
        this.PayFee = false;
        this.SaveBtn = true;
        this.SaveDisabled = false;
        this.UpdateBtn = false;
        this.showLanguageButton = false;
        this.DocTable = true;
        this.DocView = false;
        this.GetTcLcDocs();
      }
      this.spinner.hide();
    });
    return;
  }
  // ===== ATTFE: same behaviour as LANG (table + update button on REJ/REC) =====
  else if (Data.StuCertificate === 'ATTFE') {
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = 'ATTFE';

    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status && res.data.length > 0) {
        this.TclcData = res.data.filter(data => data.StuId == this.StuId && data.CertType == 'ATTFE');
        if (this.TclcData.length > 0) {
          this.Table = false;
          this.PayFee = true;
          this.PayDisabled = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          this.DocTable = true;
          this.DocView = true;
          this.PayRecpt = false;

          this.getDocDetails();

          // ===== Status handling for ATTFE (mirrors TS behaviour) =====
          switch (this.TclcData[0]['CertStatus']) {
            case "APR":
              this.Status = 'Approved';
              this.Approved = true;
              this.UpdateDisabled = true;
              break;
            case "APPAP":
              this.Status = 'Application Approved';
              this.Approved = true;
              this.UpdateDisabled = true;
              break;
            case "REJ":
              this.Status = 'Rejected';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = true;          // ← show Update for student to re-upload
              this.SaveBtn = false;
              break;
            case "REC":
              this.Status = 'Rectify';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = true;
              this.SaveBtn = false;
              break;
            case "ReSubmitted":
              this.Status = 'Re-Submitted';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = false;
              break;
            default:
              this.Status = this.TclcData[0]['CertStatus'];
              this.Approved = false;
              this.UpdateDisabled = false;
              break;
          }

          if (this.TclcData[0]['FeeStatus'] == 'Y') {
            this.PayDisabled = true;
            this.PayRecpt = true;
            this.PayFee = false;
            this.PaymentResponseId = this.TclcData[0].PaymentResponseID;
            this.Table = true;
          }
          else if (this.TclcData[0]['FeeStatus'] != 'Y') {
            this.PayRecpt = false;
            this.PayFee = true;
            this.SaveBtn = false;
            this.SaveDisabled = false;
            this.ValidateFee(this.TclcData[0]['StuId'], this.TclcData[0]['CertType'], this.TclcData[0]);
            this.Table = true;
          }
          else {
            this.PayRecpt = false;
            this.PayFee = false;
            this.SaveBtn = true;
            this.SaveDisabled = false;
          }
          // ===== END status handling =====
        } else {
          this.Table = false;
          this.PayFee = false;
          this.SaveBtn = true;
          this.SaveDisabled = false;
          this.UpdateBtn = false;
          this.DocTable = true;
          this.DocView = false;
          this.GetTcLcDocs();
        }
      } else {
        this.Table = false;
        this.PayFee = false;
        this.SaveBtn = true;
        this.SaveDisabled = false;
        this.UpdateBtn = false;
        this.DocTable = true;
        this.DocView = false;
        this.GetTcLcDocs();
      }
      this.spinner.hide();
    });
    return;
  }
  // VOD - Get data and show download button
  else if (Data.StuCertificate === 'VOD') {
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = 'VOD';

    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status && res.data.length > 0) {
        this.TclcData = res.data.filter(data => data.StuId == this.StuId && data.CertType == 'VOD');

        if (this.TclcData.length > 0) {
          this.Table = false;
          this.PayFee = true;
          this.PayDisabled = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          this.DocTable = true;
          this.DocView = true;
          this.PayRecpt = false;

          if (this.TclcData[0]['VodDocumentType'])
            this.TcLcForm.patchValue({ documentType: this.TclcData[0]['VodDocumentType'] });
          if (this.TclcData[0]['VodDocumentName'])
            this.TcLcForm.patchValue({ documentName: this.TclcData[0]['VodDocumentName'] });
          if (this.TclcData[0]['VodDocumentNumber'])
            this.TcLcForm.patchValue({ documentNumber: this.TclcData[0]['VodDocumentNumber'] });
          if (this.TclcData[0]['VodIssuingAuthority'])
            this.TcLcForm.patchValue({ issuingAuthority: this.TclcData[0]['VodIssuingAuthority'] });
          if (this.TclcData[0]['VodDateOfIssue'])
            this.TcLcForm.patchValue({ dateOfIssue: this.TclcData[0]['VodDateOfIssue'] });
          if (this.TclcData[0]['VodPurpose'])
            this.TcLcForm.patchValue({ purposeOfVerification: this.TclcData[0]['VodPurpose'] });
          if (this.TclcData[0]['VodComments'])
            this.TcLcForm.patchValue({ vodComments: this.TclcData[0]['VodComments'] });
          if (this.TclcData[0]['VodVerificationMode'])
            this.TcLcForm.patchValue({ verificationMode: this.TclcData[0]['VodVerificationMode'] });

          this.getDocDetails();

          switch (this.TclcData[0]['CertStatus']) {
            case "APR":
              this.Status = 'Approved';
              this.Approved = true;
              this.UpdateDisabled = true;
              break;
            case "APPAP":
              this.Status = 'Application Approved';
              this.Approved = true;
              this.UpdateDisabled = true;
              break;
            case "REJ":
              this.Status = 'Rejected';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = true;
              this.SaveBtn = false;
              break;
            case "REC":
              this.Status = 'Rectify';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = true;
              this.SaveBtn = false;
              break;
            case "ReSubmitted":
              this.Status = 'Re-Submitted';
              this.Approved = false;
              this.UpdateDisabled = false;
              this.UpdateBtn = false;
              break;
            default:
              this.Status = this.TclcData[0]['CertStatus'];
              this.Approved = false;
              this.UpdateDisabled = false;
              break;
          }

          if (this.TclcData[0]['FeeStatus'] == 'Y') {
            this.PayDisabled = true;
            this.PayRecpt = true;
            this.PayFee = false;
            this.showVodButton = true;
            this.checkVodAvailability();
            this.PaymentResponseId = this.TclcData[0].PaymentResponseID;
            this.Table = true;
          }
          else if (this.TclcData[0]['FeeStatus'] != 'Y') {
            this.PayRecpt = false;
            this.PayFee = true;
            this.SaveBtn = false;
            this.SaveDisabled = false;
            this.showVodButton = false;
            this.ValidateFee(this.TclcData[0]['StuId'], this.TclcData[0]['CertType'], this.TclcData[0]);
            this.Table = true;
          }
          else {
            this.PayRecpt = false;
            this.PayFee = false;
            this.SaveBtn = true;
            this.SaveDisabled = false;
            this.showVodButton = false;
          }
        } else {
          this.Table = false;
          this.PayFee = false;
          this.SaveBtn = true;
          this.SaveDisabled = false;
          this.UpdateBtn = false;
          this.showVodButton = false;
          this.DocTable = true;
          this.DocView = false;
          this.GetTcLcDocs();
        }
      } else {
        this.Table = false;
        this.PayFee = false;
        this.SaveBtn = true;
        this.SaveDisabled = false;
        this.UpdateBtn = false;
        this.showVodButton = false;
        this.DocTable = true;
        this.DocView = false;
        this.GetTcLcDocs();
      }
      this.spinner.hide();
    });
    return;
  }

  // ===================== GENERAL BRANCH: TC, LC, MC, ADMC =====================
  const payload = {};
  payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
  payload['CertType'] = 'All'
  this.umsService.GetTclcData(payload).subscribe((res) => {
    if (res.status) {
      if (res.data.length > 0) {
        this.TclcData = res.data.filter(data => data.StuId == this.StuId && data.CertType != 'TS' && data.CertType != 'ATTFE' && data.CertType != 'VOD' && data.CertType != 'RET' && data.CertType != 'ASC')

        if (this.TclcData.length > 0) {
          this.getDocDetails()

          this.DocTable = true;
          this.DocView = true;

          // ✅ UPDATED: explicit REJ branch — show Update button & enable it for student re-upload
          if (this.TclcData[0]['CertStatus'] == 'REJ'
              && this.TclcData[0]['CertType'] == Data.StuCertificate) {
            this.SaveBtn = false;
            this.UpdateBtn = true;
            this.UpdateDisabled = false;   // ← enabled
          }
          else if (this.TclcData[0]['CertType'] == Data.StuCertificate) {
            this.SaveBtn = false;
            this.UpdateBtn = true;
          }
          else {
            this.SaveBtn = true;
            this.SaveDisabled = true;
            this.UpdateBtn = false;
          }

          if (this.TclcData[0]['DestClg'] != '') {
            this.TcLcForm.controls['DestCollege'].setValue(this.TclcData[0]['DestClg'])
          }
          if (this.TclcData[0]['Reason'] != '') {
            this.TcLcForm.controls['reason'].setValue(this.TclcData[0]['Reason'])
          }
          this.CertStatus = this.TclcData[0]['CertType']
          if (this.TclcData[0]['CertStatus'] == 'APR' && this.TclcData[0]['CertType'] != "ADMC") {
            this.Approved = true
            this.spinner.hide()
          }
          else {
            this.Approved = false
            this.spinner.hide()
          }

          switch (this.TclcData[0]['CertStatus']) {
            case "APR":
              if (this.TclcData[0]['CertType'] == "ADMC") {
                if (this.TclcData[0]['RgStatus'] == "L") {
                  this.Status = 'Application Approved'
                }
                else if (this.TclcData[0]['RgStatus'] == " ") {
                  this.Status = 'Application InProcess'
                }
              }
              else {
                this.Status = 'Approved';
              }
              this.UpdateDisabled = true;
              break;
            case "APPAP":
              if (this.TclcData[0]['CertType'] == "ADMC") {
                if (this.TclcData[0]['RgStatus'] == "L") {
                  this.Status = 'Application Approved'
                }
                else if (this.TclcData[0]['RgStatus'] == " ") {
                  this.Status = 'Application InProcess'
                }
              }
              else {
                this.Status = 'Application Approved'
              }
              this.UpdateDisabled = true;
              break;
            case "REJ":
              this.Status = 'Rejected'
              this.UpdateDisabled = false;   // ✅ enabled so student can Update
              this.UpdateBtn = true;         // ✅ ensure Update button visible
              this.SaveBtn = false;
              break;
            case "REC":
              this.Status = 'Rectify'
              this.UpdateDisabled = false;
              this.UpdateBtn = true;
              this.SaveBtn = false;
              break;
            case "ReSubmitted":
              this.Status = 'Re-Submitted'
              this.UpdateDisabled = false;
              break;
            default:
              this.Status = this.TclcData[0]['CertStatus']
              this.UpdateDisabled = false;
              break
          }

          this.Table = true;
          this.spinner.hide()

        }
        else {
          this.DocTable = true;
          this.DocView = false;
          this.SaveBtn = true;
          this.SaveDisabled = false;
          this.UpdateBtn = false;
          this.Table = false
          this.TcLcForm.controls['DestCollege'].setValue('')
          this.TcLcForm.controls['reason'].setValue('')
          this.GetTcLcDocs();
          this.spinner.hide()
        }
        if (this.TclcData[0]['FeeStatus'] == 'Y') {
          this.PayDisabled = true;
          this.PayRecpt = true;
        }
        else if (this.TclcData[0]['FeeStatus'] != 'Y') {
          this.PayDisabled = false;
          this.PayRecpt = false
          this.ValidateFee(this.TclcData[0]['StuId'], this.TclcData[0]['CertType'], this.TclcData[0])
        }
      }
      else {
        this.DocTable = true;
        this.DocView = false;
        this.SaveBtn = true;
        this.SaveDisabled = false;
        this.Table = false;
        this.UpdateBtn = false;
        this.TcLcForm.controls['DestCollege'].setValue('')
        this.TcLcForm.controls['reason'].setValue('')
        this.GetTcLcDocs();
        this.spinner.hide()
      }
      this.spinner.hide()
    }
    else {
      this.SaveBtn = true;
      this.SaveDisabled = false;
      this.Table = false;
      this.UpdateBtn = false;
      this.TcLcForm.controls['DestCollege'].setValue('')
      this.TcLcForm.controls['reason'].setValue('')
      this.spinner.hide()
      this.GetTcLcDocs();
    }
  });
}

  getDocDetails() {
    this.spinner.show();
    const creds = this.TcLcForm.controls.arrData as FormArray;
    creds.clear();
    this.DocTable = true;
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = this.TcLcForm.value['StuCertificate'];
    payload['StuId'] = this.StuId;
    this.umsService.GetTcLcDocDetails(payload).subscribe({
      next: (res) => {
        console.log('GetTcLcDocDetails response:', res);
        if (res.status) {
          this.TclcDocData = res.data.filter(record => record.StuId == this.StuId);
          console.log('Filtered TclcDocData:', this.TclcDocData);
          if (this.TclcDocData.length > 0) {
            console.log('Documents found, setting DocView = true and populating arrData');
            const arrayOfObjects = this.TclcDocData;
            arrayOfObjects.forEach((obj, i) => {
              const tempObj = {};
              let regex = '';
              if (obj.RegEx !== null) {
                regex = obj.RegEx;
              }
              tempObj['DocumentName'] = new FormControl(obj.DocName);
              tempObj['SrNo'] = new FormControl(obj.SrNo);
              tempObj['DocNo'] = new FormControl(obj.DocNo);
              tempObj['docFile'] = new FormControl('');
              tempObj['DocumentFile'] = new FormControl(obj.FileUpload);
              tempObj['TclcDocId'] = new FormControl(obj.TclcDocId);

              const creds = this.TcLcForm.controls.arrData as FormArray;
              creds.push(new FormGroup(tempObj));
            });
            this.DocView = true;
          } else {
            this.DocTable = false;
            this.GetTcLcDocs();
          }
        } else {
          this.DocTable = false;
          this.GetTcLcDocs();
        }
        this.spinner.hide();  
      },
      error: (err) => {
        console.error('Error fetching document details:', err);
        this.spinner.hide();  
        this.DocTable = false;
        this.GetTcLcDocs();   
      }
    });
  }

  GetTcLcDocs() {
    const creds = this.TcLcForm.controls.arrData as FormArray;
    creds.clear()
    this.DocTable = true;
    this.DocView = false;
    const payload = {};
    payload['ModuleType'] = this.TcLcForm.value['StuCertificate']
    this.umsService.CommonDocument(payload).subscribe((res) => {
      if (res.status) {
        const arrayOfObjects = res.data;
        arrayOfObjects.forEach((obj, i) => {
          const tempObj = {}
          let regex = '';
          if (obj.RegEx !== null) {
            regex = obj.RegEx
          }
          tempObj['DocumentName'] = new FormControl(obj.DocName),
            tempObj['SrNo'] = new FormControl(obj.SrNo),
            tempObj['DocNo'] = new FormControl(obj.DocNo),
            tempObj['docFile'] = new FormControl(''),
            tempObj['DocumentFile'] = new FormControl(''),
            tempObj['TclcDocId'] = new FormControl('')

          const creds = this.TcLcForm.controls.arrData as FormArray;
          creds.push(new FormGroup(tempObj));
        })
      }
      else {
        if (this.TcLcForm.value['StuCertificate'] === 'LANG') {
          const defaultDocs = [
            { DocName: 'Passing Certificate', SrNo: 1, DocNo: 1 },
            { DocName: 'Marksheet', SrNo: 2, DocNo: 2 },
            { DocName: 'Degree Certificate', SrNo: 3, DocNo: 3 },
            { DocName: 'College Language Certificate', SrNo: 4, DocNo: 4 }
          ];
          defaultDocs.forEach(obj => {
            const tempObj = {
              DocumentName: new FormControl(obj.DocName),
              SrNo: new FormControl(obj.SrNo),
              DocNo: new FormControl(obj.DocNo),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(''),
              TclcDocId: new FormControl('')
            };
            creds.push(new FormGroup(tempObj));
          });
          this.DocTable = true;
        } else if (this.TcLcForm.value['StuCertificate'] === 'VOD') {
          const defaultDocs = [
            { DocName: 'Original Document Copy', SrNo: 1, DocNo: 1 },
            { DocName: 'Self-Attested Copy', SrNo: 2, DocNo: 2 },
            { DocName: 'Verification Request Form', SrNo: 3, DocNo: 3 }
          ];
          defaultDocs.forEach(obj => {
            const tempObj = {
              DocumentName: new FormControl(obj.DocName),
              SrNo: new FormControl(obj.SrNo),
              DocNo: new FormControl(obj.DocNo),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(''),
              TclcDocId: new FormControl('')
            };
            creds.push(new FormGroup(tempObj));
          });
          this.DocTable = true;
        } else {
          this.DocTable = false;
        }
      }
    })
  }

  getSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.InstId = res.projectPharam['ClubPartTrans']
    })
  }

  dowload(data) {
    this.redirectTo('Certificate', data.CertType)
    return

    if (data.CertType == 'TC') {
      this.RptCode = 134
    }
    else if (data.CertType == 'LC') {
      this.RptCode = 135
    }
    else if (data.CertType == 'MC') {
      this.RptCode = 136
    }
    var filter: any;
    let payload1 = {}
    payload1['StudentId'] = data.StudId;
    let jsonString = JSON.stringify(payload1);
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
      "RptCode": this.RptCode,
      "InstName": '',
      "InstNo": this.InstId,
      "ShId": '',
      "CgCode": data.StuCollege,
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": parseInt(sessionStorage.getItem('StudentRGID')),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": data.StuCourse,
      "SnNo": data.SnNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

 PayFees() {
  const Data = this.TcLcForm.value;

  if (Data.StuCertificate === 'ASC' || Data.StuCertificate === 'RET') {
    const payableRows = this.payableHeads;
    if (!Array.isArray(payableRows) || payableRows.length === 0) {
      let data = { message: 'No unpaid records found for the selected Subject Heads.', title: 'Information', icon: 'fas fa-info-circle' };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      return;
    }
    const selectedSubjectIds: number[] = Array.isArray(this.TcLcForm.value.SelectedSubject)
      ? this.TcLcForm.value.SelectedSubject.map((v: any) => Number(v)).filter((v: number) => !!v && !isNaN(v) && v > 0)
      : [];

    const selectedHeadIds: number[] = Array.isArray(this.TcLcForm.value.SelectedSubjectHead)
      ? this.TcLcForm.value.SelectedSubjectHead.map((v: any) => Number(v)).filter((v: number) => !!v && !isNaN(v) && v > 0)
      : [];

    this.Tclcdata = payableRows.map(row => ({
      "StuCourse": row.StuCourse,
      "StuCollege": row.StuCollege,
      "SnNo": row.SnNo,
      "CertType": row.CertType,
      "StuSubId": row.StuSubId,
      "TclcId": row.TclcId,
      "AllSubjectData": this.AllSubjectData,
      "PayableHeadsCount": payableRows.length,
      "SelectedSubjectIds": selectedSubjectIds,
      "SelectedHeadIds": selectedHeadIds,
      "SelectedSubjectCount": selectedSubjectIds.length,
      "SelectedHeadCount": selectedHeadIds.length
    }));

    this.umsService.setTclcData(this.Tclcdata);
    this.redirect('TCLCFees');
    return;
  }

  let selectedSubIds: any = this.TcLcForm.value.SelectedSubjectHead || 0;

  const selectedSubjectIds: number[] = Array.isArray(this.TcLcForm.value.SelectedSubject)
    ? this.TcLcForm.value.SelectedSubject.map((v: any) => Number(v)).filter((v: number) => !!v && !isNaN(v) && v > 0)
    : [];

  const selectedHeadIds: number[] = Array.isArray(this.TcLcForm.value.SelectedSubjectHead)
    ? this.TcLcForm.value.SelectedSubjectHead.map((v: any) => Number(v)).filter((v: number) => !!v && !isNaN(v) && v > 0)
    : [];

  this.Tclcdata.push({
    "StuCourse": Data.StuCourse,
    "StuCollege": Data.StuCollege,
    "SnNo": parseInt(sessionStorage.getItem('session')),
    "CertType": Data.StuCertificate,
    "StuSubId": selectedSubIds,
    "AllSubjectData": this.AllSubjectData,
    "SelectedSubjectIds": selectedSubjectIds,
    "SelectedHeadIds": selectedHeadIds,
    "SelectedSubjectCount": selectedSubjectIds.length,
    "SelectedHeadCount": selectedHeadIds.length
  });

  this.umsService.setTclcData(this.Tclcdata);
  this.redirect('TCLCFees');
}

  RgId(StuId) {
    this.spinner.show()
    const payload = {};
    payload['StuId'] = StuId;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.SaveDisabled = false;
        this.SaveBtn = true;
      }
      else {
        this.spinner.hide()
        this.SaveDisabled = true;
        this.SaveBtn = false;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisabled = true;
      this.SaveBtn = false;
    })
  }

  Reset() {
    this.ngOnInit()
  }


  TypeUni() {
    if (this.TcLcForm.value['DestCollege'] == 'Other') {
      this.Other = true;
    }
    else {
      this.Other = false;
    }
  }

  getFeeTempData() {
    const Data = this.TcLcForm.value

    // For ASC / RET: use only paid rows (receiptHeads) and use its PaymentResponseID
    if (Data.StuCertificate === 'ASC' || Data.StuCertificate === 'RET') {
      const receiptRows = this.receiptHeads;
      if (!Array.isArray(receiptRows) || receiptRows.length === 0) {
        let data = { message: 'No paid records found for the selected Subject Heads.', title: 'Information', icon: 'fas fa-info-circle' };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        return;
      }
      this.PaymentResponseId = receiptRows[0].PaymentResponseID || null;

      this.spinner.show();
      const payload = {};
      payload['FeeType'] = Data.StuCertificate;
      this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          this.addnewrecord(res.data[0]['TemplateCode']);
        }
      });
      return;
    }

    this.spinner.show();
    const payload = {};
    payload['FeeType'] = this.TcLcForm.value['StuCertificate']
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.addnewrecord(res.data[0]['TemplateCode'])
      }
    })
  }

  onExamChange(event: any) {
    this.getSubjectsForCourse();
  }

    getSubjectsForCourse() {
    const EmId = this.TcLcForm.value.StuExam;
    const BranchId = this.TcLcForm.value.StuBranch;
    if (!EmId) {
      return;
    }
    this.Subjects = [];
    this.SubjectName = [];
    this.GroupData = [];
    this.selectedOptions = [];
    this.selectedCheckboxes = [];
    this.AllSub = [];
    this.SubjectData = [];
    this.subjectList = [];
    this.filteredSubjectList = [];
    this.subjectHeadList = [];
    this.filteredSubjectHeadList = [];
    this.allSubjectHeadsSelected = false;
    this.allSubjectsSelected = false;

    this.Subs = false;
    this.OptSub = false;

    this.spinner.show();
    this.TcLcForm.get('SelectedSubject')?.reset();
    this.TcLcForm.get('SelectedSubjectHead')?.reset();

    const payload = {
      EsEmId: EmId,
      EsStrId: BranchId
    };

    this.umsService.getExamSubMapFetch(payload).subscribe(
      async (res) => {
        this.spinner.hide();

        if (!res.status || !res.data?.children?.length) {
          return;
        }

        this.SubjectData = res.data.children;
        const allHeadsMap = new Map<number, any>();

        this.SubjectData.forEach(parent => {
          if (parent.EsType === 'S') {
            this.Subs = true;

            this.subjectList.push({
              SubCode: parent.EsCode,
              SubName: parent.EsName,
              EsId: parent.EsId
            });

            if (!this.Subjects.includes(parent.EsCode)) {
              this.Subjects.push(parent.EsCode);
              this.SubjectName.push(parent.EsName);
              this.AllSub.push(parent);
            }
            if (parent.EsOpCode !== ' ') {
              if (!this.selectedOptions.includes(parent.EsOpCode)) {
                this.selectedOptions.push(parent.EsOpCode);
              }
            }

            if (parent.EsOpCode === ' ') {
              if (!this.selectedCheckboxes.some(x => x.EsId === parent.EsId)) {
                this.selectedCheckboxes.push(parent);
              }
            }

            // Collect subject heads, tracking which parent subject they belong to
            this.collectSubjectHeads(parent, allHeadsMap, parent.EsId);

            this.newSelectedValues?.forEach(sel => {
              if (sel.Code === parent.EsCode && sel.Id === parent.EsParent) {
                if (!this.selectedCheckboxes.some(x => x.EsId === parent.EsId)) {
                  this.selectedCheckboxes.push(parent);
                }
              }
            });
          }
          else if (parent.EsType === 'G') {
            this.OptSub = true;

            if (!this.GroupData.some(x => x.EsId === parent.EsId)) {
              this.GroupData.push(parent);
            }

            if (parent.EsOpCode !== ' ') {
              if (!this.selectedOptions.includes(parent.EsOpCode)) {
                this.selectedOptions.push(parent.EsOpCode);
              }
            }

            parent.children?.forEach(child => {
              this.subjectList.push({
                SubCode: child.EsCode,
                SubName: child.EsName,
                EsId: child.EsId
              });
              if (child.EsOpCode !== ' ') {
                if (!this.selectedOptions.includes(child.EsOpCode)) {
                  this.selectedOptions.push(child.EsOpCode);
                }
              }

              if (child.EsOpCode === ' ') {
                if (!this.selectedCheckboxes.some(x => x.EsId === child.EsId)) {
                  this.selectedCheckboxes.push(child);
                }
              }

              // Collect subject heads from group children
              this.collectSubjectHeads(child, allHeadsMap, child.EsId);

              this.newSelectedValues?.forEach(sel => {
                if (sel.Code === child.EsCode && sel.Id === child.EsParent) {
                  if (!this.selectedCheckboxes.some(x => x.EsId === child.EsId)) {
                    this.selectedCheckboxes.push(child);
                  }
                }
              });
            });
          }
        });

        // Store ALL heads with their owning subject id for filtering later
        this.allSubjectHeadsWithParent = Array.from(allHeadsMap.values());
        this.subjectHeadList = [...this.allSubjectHeadsWithParent];
        this.filteredSubjectHeadList = [...this.subjectHeadList];

        this.filteredSubjectList = [...this.subjectList];

        // Subscribe to subject selection changes to filter heads
        this.listenToSubjectChanges();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        console.error('Error fetching subjects:', error);
      }
    );
  }

   // Recursively collect all EsType === 'H' nodes, tagging with the owning Subject EsId
  collectSubjectHeads(node: any, map: Map<number, any>, owningSubjectId: number) {
    if (node.EsType === 'H' && node.NotPrintAdmitCrd == 0) {
      if (!map.has(node.EsId)) {
        map.set(node.EsId, {
          EsId: node.EsId,
          EsCode: node.EsCode,
          EsName: node.EsName,
          EsParent: node.EsParent,
          EsType: node.EsType,
          OwningSubjectId: owningSubjectId
        });
      }
    }
    if (node.children && node.children.length > 0) {
      node.children.forEach((child: any) => {
        this.collectSubjectHeads(child, map, owningSubjectId);
      });
    }
  }
      // Filter Subject Heads based on selected Subjects
  listenToSubjectChanges() {
    if (this.subjectChangeSub) {
      this.subjectChangeSub.unsubscribe();
    }
    this.subjectChangeSub = this.TcLcForm.get('SelectedSubject')?.valueChanges.subscribe(
      (selectedSubjects: any[]) => {
        if (!Array.isArray(selectedSubjects) || selectedSubjects.length === 0) {
          // If nothing is selected, show all heads
          this.subjectHeadList = [...this.allSubjectHeadsWithParent];
        } else {
          // Only show heads whose owning subject is in the selected list
          this.subjectHeadList = this.allSubjectHeadsWithParent.filter(h =>
            selectedSubjects.includes(h.OwningSubjectId)
          );
        }
        this.filteredSubjectHeadList = [...this.subjectHeadList];

        // Remove any selected head that is no longer visible
        const currentSelectedHeads = this.TcLcForm.value.SelectedSubjectHead || [];
        if (Array.isArray(currentSelectedHeads) && currentSelectedHeads.length > 0) {
          const validHeadIds = this.subjectHeadList.map(h => h.EsId);
          const cleanedHeads = currentSelectedHeads.filter((id: number) => validHeadIds.includes(id));
          if (cleanedHeads.length !== currentSelectedHeads.length) {
            this.TcLcForm.controls['SelectedSubjectHead'].setValue(cleanedHeads);

            // Refresh table + buttons for ASC / RET because setValue above doesn't fire selectionChange
            const cert = this.TcLcForm.value['StuCertificate'];
            if (cert === 'ASC' || cert === 'RET') {
              this.onSubjectHeadChange({ value: cleanedHeads });
            }
          }
        }

        // Update Select All state
        this.allSubjectHeadsSelected =
          this.subjectHeadList.length > 0 &&
          this.subjectHeadList.every(h => (this.TcLcForm.value.SelectedSubjectHead || []).includes(h.EsId));
      }
    );
  }

  // Helper method to get subject name by EsId for ASC / RET payment status table
  getSubjectNameById(esId: any): string {
    if (!esId) {
      return '';
    }
    const found = this.subjectList.find(s => s.EsId === esId);
    return found ? found.SubName : '';
  }

  // Helper method to get subject head name by EsId for ASC / RET payment status table
  getSubjectHeadNameById(esId: any): string {
    if (!esId) {
      return '';
    }
    const found = this.subjectHeadList.find(h => h.EsId === esId);
    return found ? found.EsName : '';
  }

  addnewrecord(TempCode) {
    let data = {
      PaymentResponseId: this.PaymentResponseId,
      CertType: this.TcLcForm.value.StuCertificate,
    };
    data['SnNo'] = parseInt(sessionStorage.getItem('session'))
    data['TemplateCode'] = TempCode
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  saveApplicationDetails() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    let Name = this.TcLcForm.value.StuCertificate
    payload['StuId'] = this.StuId;
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'))
    payload['CgCode'] = this.TcLcForm.value['StuCollege']
    payload['CoCode'] = this.TcLcForm.value['StuCourse']
    payload['ApplicationName'] = Name
    payload['ApplicationSubDate'] = formattedDate
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    })
  }

  onChange($event: Event, rowIndex: number) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    const faControl = (<FormArray>this.TcLcForm.controls['arrData']).at(rowIndex);

    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {
        message: this.errormessage,
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
      });
    } else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
      if (ext === "pdf") {
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(fileName);
        faControl['controls'].DocumentFile.markAsTouched();
      } else {
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
        faControl['controls'].DocumentFile.markAsTouched();
        let data = {
          message: 'Please Upload Only PDF File',
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }


  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      if (!this.fileUploads) {
        this.fileUploads = [];
      }

      if (!this.fileUploads[rowIndex]) {
        this.fileUploads[rowIndex] = {};
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.TcLcForm.controls['arrData']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);

    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  showbase64(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.value.DocumentFile
      });
  }

  ValidateFee(StuId, FeeType, Data, Data1?) {
    const payload = {}
    payload['StuId'] = StuId;
    payload['FeeType'] = FeeType;
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      this.getFeeTempData2(StuId, FeeType, Data, Data1);
    })
  }

  getFeeTempData2(StuId, FeeType, Data, Data1?) {
    this.spinner.show();
    const payload = {};
    payload['FeeType'] = FeeType;
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SearchFeeDetails(res.data[0]['TemplateCode'], StuId, Data, Data1)
      } else {
        this.spinner.hide();
      }
    });
  }

  SearchFeeDetails(TempCode, StdId, Data, Data1?) {
    this.spinner.show();
    const payload = {};
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = sessionStorage.getItem('session')
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        if (Data['CertType'] === 'ASC' || Data['CertType'] === 'RET') {
          if (res.data.length >= 1) {
            const usedPaymentIds = new Set(
              Data1
                .filter(tclcItem => tclcItem.PaymentResponseID != null)
                .map(tclcItem => Number(tclcItem.PaymentResponseID))
            );
            const availablePaymentIds = res.data
              .map(x => Number(x.PaymentResponseID))
              .filter(id => !usedPaymentIds.has(id));

            if (availablePaymentIds.length === 0) {
              return;
            }

            let paymentIndex = 0;

            Data1.forEach(async tclcItem => {
              if (tclcItem.PaymentResponseID) {
                return;
              }
              if (paymentIndex < availablePaymentIds.length) {
                const freePaymentId = availablePaymentIds[paymentIndex];

                let newParm = { PaymentResponseID: freePaymentId };
                tclcItem.PaymentResponseID = freePaymentId;
                usedPaymentIds.add(freePaymentId);
                await this.updateTC(StdId, tclcItem, newParm);
                paymentIndex++;
              } else {
              }
            });
          }
          return;
        }
        this.updateTC(StdId, Data)
      } else {
        this.PayDisabled = false;
        this.PayRecpt = false;
        this.PayFee = true
      }
    });
  }

 updateTC(StdId, Data, newParm?): Promise<any> {
    return new Promise((resolve, reject) => {
      let payload: any = {};
      if (Data['CertType'] === 'ASC' || Data['CertType'] === 'RET') {
        // StuSubId = the head id stored on the tclc row
        payload['StuSubId'] = Data['StuSubId'] || 0;

        if (newParm) {
          payload['PaymentResponseID'] = newParm.PaymentResponseID;
        }
      }

      payload['StuFaculty'] = Data['StuFaculty'];
      payload['StuCourse'] = Data['StuCourse'];
      payload['StuCollege'] = Data['StuCollege'];
      payload['StuExam'] = Data['StuExam'];
      payload['StuBranch'] = Data['StuBranch'];
      payload['SnNo'] = parseInt(sessionStorage.getItem('session'));
      payload['CertType'] = Data['CertType'];
      payload['DestClg'] = Data['DestClg'];
      payload['Reason'] = Data['Reason'];
      payload['FeeStatus'] = 'Y';
      payload['CertStatus'] = 'Fees Paid';
      payload['StuId'] = Data['StuId'];
      payload['TclcId'] = Data['TclcId'];
      payload['Comment'] = '';
      payload['CertScr'] = '';
      payload['StatusBy'] = sessionStorage.getItem('loginId');
      if (Data['CertType'] === 'LANG') {
        payload['MobileNo'] = Data['MobileNo'] || this.TcLcForm.value.mobileNo;
        payload['Email'] = Data['Email'] || this.TcLcForm.value.email;
        payload['Address'] = Data['Address'] || this.TcLcForm.value.address;
        payload['DeliveryOpt'] = Data['DeliveryOpt'] || this.TcLcForm.value.DeliveryOpt;
        payload['EmailId'] = Data['EmailId'] || this.TcLcForm.value.emailId;
        payload['PostalAdd'] = Data['PostalAdd'] || this.TcLcForm.value.postalAdd;
        payload['DeliverAt'] = Data['DeliverAt'] || this.TcLcForm.value.deliverAt;
        payload['IsSameAddr'] = Data['IsSameAddr'] || (this.TcLcForm.value.isSameAddr ? 'Y' : 'N');
      }

      this.umsService.UpdateTclc(payload).subscribe(
        (res) => {
          if (res.status) {
            if (Data['CertType'] === 'ASC' || Data['CertType'] === 'RET') {
              // After payment, re-check per-row Answer Sheet availability
              this.checkAnswerSheetAvailabilityForAllRows();
            } else if (Data['CertType'] === 'LANG') {
              this.showLanguageButton = true;
              this.checkLanguageCertificateAvailability();
            } else if (Data['CertType'] === 'VOD') {
              this.showVodButton = true;
              this.checkVodAvailability();
            }
            // REMOVED this.ShowGrid() — it caused an infinite loop for LANG
            // because ShowGrid() re-triggers ValidateFee() -> SearchFeeDetails() -> updateTC()
            resolve(res);
          } else {
            reject(res);
          }
        },
        (err) => reject(err)
      );
    });
  }

  // LANG specific methods
  shouldShowLanguageDownloadButton(): boolean {
    return this.TcLcForm.value['StuCertificate'] === 'LANG' &&
      this.showLanguageButton &&
      this.TclcData &&
      this.TclcData.length > 0;
  }

  isLanguageDownloadDisabled(): boolean {
    return this.languageDownloadDisabled || !this.languageCertAvailable;
  }

  checkLanguageCertificateAvailability(): void {
  if (this.TcLcForm.value['StuCertificate'] !== 'LANG') {
    this.showLanguageButton = false;
    return;
  }
  //  Guard: prevent repeated API calls that caused the infinite loop
  if (this.langAvailabilityChecked) return;
  this.langAvailabilityChecked = true;

  if (this.TclcData && this.TclcData.length > 0) {
    const langRecord = this.TclcData.find((t: any) => t.CertType === 'LANG');
    if (!langRecord || langRecord.FeeStatus !== 'Y') {
      this.languageCertAvailable = false;
      this.languageDownloadDisabled = true;
      this.showLanguageButton = false;
      return;
    }
  } else {
    this.showLanguageButton = false;
    return;
  }
  const session = JSON.parse(sessionStorage.getItem('session') || '{}');
  const payload = {
    SessionId: session.SessionId || session.SnNo || 0,
    StuId: Number(sessionStorage.getItem('StudentPersonalId')) || 0,
    Emid: Number(sessionStorage.getItem('StuEmId')) || 0,
  };

  console.log('Language Payload:', payload);

  this.umsService.GetTcLcDocUploadDetails(payload).subscribe({
    next: (res: any) => {
      if (!res?.status || !res?.data?.length) {
        this.languageCertAvailable = false;
        this.languageDownloadDisabled = true;
        this.languageCertData = null;
        this.showPopup('No language certificate data found. Please contact administrator.', 'Information');
        return;
      }
      const langDocs = res.data.filter((doc: any) => doc.CertType === 'LANG');

      if (langDocs.length === 0) {
        this.languageCertAvailable = false;
        this.languageDownloadDisabled = true;
        this.languageCertData = null;
        this.waitingForAdminUploadLang = true;
        this.showPopup('Language certificate has not been uploaded by admin yet. Please try again in a few days.', 'Information');
        return;
      }
      let matchedDoc = langDocs.find((doc: any) => doc.FileUpload && doc.FileUpload.trim() !== '');
      if (!matchedDoc && langDocs.length > 0) {
        matchedDoc = langDocs.find((doc: any) => doc.FileUpload && doc.FileUpload.trim() !== '');
      }

      if (matchedDoc) {
        this.languageCertAvailable = true;
        this.languageCertData = matchedDoc;
        this.waitingForAdminUploadLang = false;

        const conditionsMatch = this.checkDownloadConditionsLang(matchedDoc);
        this.languageDownloadDisabled = !conditionsMatch;

        if (!conditionsMatch) {
          this.showPopup('Language certificate is available but does not match required criteria. Please contact administrator.', 'Information');
        } else {
          this.showLanguageButton = true;
        }
      } else {
        this.languageCertAvailable = false;
        this.languageDownloadDisabled = true;
        this.languageCertData = null;
        this.waitingForAdminUploadLang = true;
        this.showPopup('Language certificate has not been uploaded by admin yet. Please try again in a few days.', 'Information');
      }
    },
    error: (err) => {
      console.error('Error checking language certificate:', err);
      this.languageCertAvailable = false;
      this.languageDownloadDisabled = true;
      this.showPopup('Unable to check language certificate availability. Please try again later.', 'Error');
    }
  });
}

  private handleNoLangDocument(): void {
    this.languageCertAvailable = false;
    this.languageDownloadDisabled = true;
    this.languageCertData = null;
    
    if (!this.waitingForAdminUploadLang) {
      this.waitingForAdminUploadLang = true;
      this.lastCheckedTimeLang = new Date();
      this.showPopup('Language certificate has not been uploaded by admin yet. Please try again in a few days.', 'Information');
    } else if (this.lastCheckedTimeLang) {
      const now = new Date();
      const diffInHours = (now.getTime() - this.lastCheckedTimeLang.getTime()) / (1000 * 60 * 60);
      if (diffInHours >= 24 && this.retryCountLang < this.maxRetriesLang) {
        this.retryCountLang++;
        this.lastCheckedTimeLang = now;
        this.showPopup(`Still waiting for admin upload. Retry ${this.retryCountLang} of ${this.maxRetriesLang}.`, 'Information');
      } else if (this.retryCountLang >= this.maxRetriesLang) {
        this.showPopup('Maximum retry attempts reached. Please contact administrator.', 'Error');
        this.languageDownloadDisabled = true;
      }
    }
  }

  checkDownloadConditionsLang(docData: any): boolean {
    try {
      if (this.TcLcForm.value['StuCertificate'] !== 'LANG') return false;

      if (this.TclcData && this.TclcData.length > 0) {
        const langRecord = this.TclcData[0];
        if (!langRecord || langRecord.FeeStatus !== 'Y') return false;
      }

      if (!docData || !docData.FileUpload || docData.FileUpload.trim() === '') return false;

      if (this.waitingForAdminUploadLang && this.lastCheckedTimeLang) {
        const now = new Date();
        const diffInHours = (now.getTime() - this.lastCheckedTimeLang.getTime()) / (1000 * 60 * 60);
        if (diffInHours < 24) return false;
      }

      return true;
    } catch (error) {
      console.error('Error checking language download conditions:', error);
      return false;
    }
  }

 downloadLanguageCertificate(): void {
  if (!this.languageCertAvailable) {
    this.showPopup('Language certificate is not available for download.', 'Information');
    return;
  }
  if (this.languageDownloadDisabled) {
    this.showPopup('Cannot download language certificate. Please ensure all conditions are met.', 'Information');
    return;
  }
  if (!this.checkDownloadConditionsLang(this.languageCertData)) {
    this.showPopup('Language certificate does not match required criteria. Please contact administrator.', 'Information');
    return;
  }

  const session = JSON.parse(sessionStorage.getItem('session') || '{}');
  const payload = {
    SessionId: session.SessionId || session.SnNo || 0,
    StuId: Number(sessionStorage.getItem('StudentPersonalId')) || 0,
    Emid: Number(sessionStorage.getItem('StuEmId')) || 0, 
  };

 this.spinner.show();
  this.umsService.GetTcLcDocUploadDetails(payload).subscribe({
    next: (res: any) => {
      this.spinner.hide();
      if (!res?.status || !res?.data?.length) {
        this.showPopup('No document data found.', 'Error');
        return;
      }

      const doc = res.data.find((d: any) => d.CertType === 'LANG' && d.FileUpload && d.FileUpload.trim() !== '');
      if (!doc || !doc.FileUpload) {
        this.showPopup('Language certificate has not been uploaded by admin yet. Please try again in a few days.', 'Information');
        this.waitingForAdminUploadLang = true;
        this.lastCheckedTimeLang = new Date();
        return;
      }

      this.downloadPDFFile(doc);
      this.waitingForAdminUploadLang = false;
      this.retryCountLang = 0;
    },
    error: (err) => {
      this.spinner.hide();
      console.error('Download failed', err);
      this.showPopup('Download failed. Please try again.', 'Error');
      this.retryCountLang++;
      if (this.retryCountLang >= this.maxRetriesLang) {
        this.showPopup('Maximum retry attempts reached. Please contact administrator.', 'Error');
        this.languageDownloadDisabled = true;
      }
    }
  });
}

  // Shared PDF download helper (also used by Answer Sheet Copy and Language Certificate)
  downloadPDFFile(doc: any): void {
    let base64Data = doc.FileUpload;

    if (base64Data.startsWith('data:application/pdf;base64,')) {
      base64Data = base64Data.split(',')[1];
    } else if (base64Data.startsWith('data:')) {
      base64Data = base64Data.split(',')[1];
    }

    try {
      const byteArray = new Uint8Array(atob(base64Data).split('').map(c => c.charCodeAt(0)));
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      // Dynamic fallback file name based on the current certificate type (ASC / RET)
      const fallbackName = (this.TcLcForm?.value?.StuCertificate === 'RET' || this.TcLcForm?.value?.StuCertificate === 'ASC')
        ? this.getCertDefaultFileName()
        : 'Photocopy of answerbook.pdf';

      const a = document.createElement('a');
      a.href = url;
      a.download = doc.DocName ? `${doc.DocName}.pdf` : fallbackName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);

      this.showPopup('downloaded successfully.', 'Success');
    } catch (err) {
      console.error('Error creating PDF:', err);
      this.showPopup('Error downloading file. Please try again.', 'Error');
    }
  }

  showPopup(message: string, title: string = 'Information'): void {
    let data = {
      message: message,
      title: title,
      icon: title === 'Error' ? 'fas fa-close' :
        title === 'Success' ? 'fas fa-check' : 'fas fa-info-circle'
    };

    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    this.dialogRef.afterClosed().subscribe(result => {

    });
  }
}